import type { PromptResolve } from '@ur-solutions/react-components'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import { RegularModal, Select } from '@/components_deprecated'
import { Field, Form } from '@/modules/companies'
import React from 'react'
import { ExportFormat } from '@/modules/exports'
import { useExportFormatOptions } from '../exports/hooks'

interface ExportFormatPromptProps {
  onSubmit: PromptResolve<{ exportFormat: ExportFormat } | null>
}

export const ExportFormatPrompt: React.FC<ExportFormatPromptProps> = ({
  onSubmit,
}) => {
  const translations = useTranslate({
    export: 'common.export',
    exportFormat: 'common.export-format',
    excel: 'common.excel',
    pdf: 'common.pdf',
  })

  const options = useExportFormatOptions()

  const {
    formValues: form,
    updateForm,
    submitHandler: submit,
  } = useForm({
    values: {
      exportFormat: ExportFormat.PDF,
    },
    config: {
      storage: {
        storeFormState: true,
        retrieveFormStateOnMount: true,
        storeFormStateName: 'Export-equipments-form',
        transformValues: {
          exportFormat: value => value as ExportFormat,
        },
      },
    },
  })

  return (
    <RegularModal
      title={translations.export}
      width="400px"
      submitText={translations.export}
      onCancel={() => onSubmit(null)}
      onSubmit={submit(onSubmit)}
    >
      <Form>
        <Field>
          <label>{translations.exportFormat}</label>
          <Select
            value={form.exportFormat}
            options={options}
            fullWidth
            height="3.875rem"
            onChange={value =>
              updateForm({
                exportFormat: value ?? ExportFormat.PDF,
              })
            }
          />
        </Field>
      </Form>
    </RegularModal>
  )
}
